/*@flow*/
import type { Element } from 'react';
import React, { useState, useEffect } from 'react';
import useBuilderCommands from '../useCommands';
import useBuilderContextState from '../useContextState';
import Task from 'folktale/concurrency/task';
import pluralize from 'pluralize';
import api from 'lib/api';
import underscored from 'underscore.string/underscored';
import PATHS from 'const/paths';
import { set } from 'ops';
import useCommands from 'comps/Left2/useCommands';

function DestroyBtn(props: { onError: Function }): null | Element<'a'> {
  const cmd2 = useBuilderCommands();
  const { resource, resourceName } = useBuilderContextState();
  const id = resource.get('id');
  const [isLoading, setLoading] = useState(false);
  const cmd = useCommands();

  useEffect(() => {
    if (!isLoading || !id) return;
    const path = `/${underscored(pluralize(resourceName))}/${id}`;
    const getDestroy = Task.fromPromised(() =>
      api.fetch(path, { method: 'DELETE' })
    );
    const taskExecution = getDestroy().run();
    taskExecution.listen({
      onResolved: () => {
        cmd2.close();
        cmd.closePanel();
        setTimeout(() => {
          set(PATHS.projectRefetchHash, Math.random());
        }, 600);
      },
      onRejected(err) {
        props.onError([err]);
      },
      onCancelled() {},
    });
    return () => taskExecution.cancel();
  }, [isLoading, id]);

  if (!id) return null;

  return (
    <a
      data-testid="DestroyResource"
      className="btn btn-outline-danger mr-2 text-danger"
      onClick={() => {
        const ans = confirm('Are you sure you want to destroy this?');
        if (!ans) {
          return;
        }
        setLoading(true);
      }}
    >
      Remove <i className="fa fa-trash" />
    </a>
  );
}

export default DestroyBtn;
